import styled, { keyframes } from "styled-components";

import Refresh from "../icons/sun_on.svg?react";
import WhiteSun from "../icons/white-sun.svg?react";

const spin = keyframes`
  0% {
    transform: rotate(0deg);
  }
  100% {
    transform: rotate(360deg);
  }
`;

// const backSpin = keyframes`
//   0% {
//     transform: rotate(0deg);
//   }
//   100% {
//     transform: rotate(-360deg);
//   }
// `;

const StyledRefresh = styled.div<{
	$fullScreen?: boolean;
	$dim: boolean;
	$showBackGround: boolean;
	$backspin?: boolean;
}>`
  width: ${(props) => (props.$fullScreen ? "100vw" : "100%")};
  height: ${(props) => (props.$fullScreen ? "100vh" : "100%")};
  position: ${(props) => (props.$fullScreen ? "absolute" : "relative")};
  top: ${(props) => (props.$fullScreen ? "0" : "unset")};
  left: ${(props) => (props.$fullScreen ? "0" : "unset")};
  opacity: ${(props) => (props.$dim ? ".2" : ".8")};
  display: flex;
  justify-content: center;
  align-items: center;
  background-color: ${(props) => (props.$showBackGround ? props.theme.backgroundColor : "unset")};
  svg {
    width: ${(props) => (props.$fullScreen ? "5rem" : "2rem")};
    height: ${(props) => (props.$fullScreen ? "5rem" : "2rem")};
    animation : ${spin} 1s linear infinite ${(props) => (props.$backspin ? "reverse" : "normal")};

    @media (prefers-reduced-motion: reduce) {
      animation: none;
    }
  }
  z-index: ${(props) => (props.$fullScreen ? "2" : "unset")};
`;

function RefreshSpinner({
	fullScreen,
	area,
	dim = false,
	showBackGround,
	whiteSun,
	backspin = false,
}: {
	fullScreen?: boolean;
	area?: string;
	dim?: boolean;
	showBackGround: boolean;
	whiteSun?: boolean;
	backspin?: boolean;
}) {
	area;
	return (
		<StyledRefresh
			data-testid="spinner"
			$fullScreen={fullScreen}
			$dim={dim}
			$showBackGround={showBackGround}
			$backspin={backspin}
		>
			{!whiteSun && <Refresh aria-hidden="true" className="refresh" />}
			{whiteSun && <WhiteSun aria-hidden="true" className="refresh" />}
		</StyledRefresh>
	);
}

export default RefreshSpinner;
